/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateMetricValueDto
 */
export interface UpdateMetricValueDto {
    /**
     * Integer value for the metric
     * @type {number}
     * @memberof UpdateMetricValueDto
     */
    valueInt?: number;
    /**
     * Float value for the metric
     * @type {number}
     * @memberof UpdateMetricValueDto
     */
    valueFloat?: number;
    /**
     * Text value for the metric
     * @type {string}
     * @memberof UpdateMetricValueDto
     */
    valueText?: string;
    /**
     * Multi-dimensional values as JSON
     * @type {object}
     * @memberof UpdateMetricValueDto
     */
    multiDimValues?: object;
    /**
     * Start date and time of the measurement
     * @type {Date}
     * @memberof UpdateMetricValueDto
     */
    startDate?: Date;
    /**
     * End date and time of the measurement (must be after startDate)
     * @type {Date}
     * @memberof UpdateMetricValueDto
     */
    endDate?: Date;
}

/**
 * Check if a given object implements the UpdateMetricValueDto interface.
 */
export function instanceOfUpdateMetricValueDto(value: object): value is UpdateMetricValueDto {
    return true;
}

export function UpdateMetricValueDtoFromJSON(json: any): UpdateMetricValueDto {
    return UpdateMetricValueDtoFromJSONTyped(json, false);
}

export function UpdateMetricValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMetricValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'valueInt': json['valueInt'] == null ? undefined : json['valueInt'],
        'valueFloat': json['valueFloat'] == null ? undefined : json['valueFloat'],
        'valueText': json['valueText'] == null ? undefined : json['valueText'],
        'multiDimValues': json['multiDimValues'] == null ? undefined : json['multiDimValues'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
    };
}

export function UpdateMetricValueDtoToJSON(json: any): UpdateMetricValueDto {
    return UpdateMetricValueDtoToJSONTyped(json, false);
}

export function UpdateMetricValueDtoToJSONTyped(value?: UpdateMetricValueDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'valueInt': value['valueInt'],
        'valueFloat': value['valueFloat'],
        'valueText': value['valueText'],
        'multiDimValues': value['multiDimValues'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
    };
}

